export enum RecipientListEnums {
  Memberships = 'memberships',
  Interests = 'interests'
}
